import DOMPurify from 'dompurify';

// Sanitiza HTML provisto por la empresa (p.ej. welcome_message) antes de
// inyectarlo en la página pública del quiz, evitando XSS almacenado.
export function sanitizeHtml(html) {
    if (!html) return '';
    return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}
